import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  TextField,
  Typography,
  Checkbox,
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  IconButton,
  Button,
  InputAdornment,
  TextareaAutosize,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

import axios from "axios";
import ApiServices from "../../../../Utils/ApiServices/ApiServices";
import { getDecryptedAccessToken, getDecryptedData } from "../../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const CreateBill = ({ data ,onBillCreated}) => {
  const [doctorServices, setDoctorServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [serviceNotes, setServiceNotes] = useState({});
  const [discounts, setDiscounts] = useState({});
  const AccessToken = getDecryptedAccessToken();
  const LoginUserData = getDecryptedData();
  const [snackBarMessage, setsnackBarMessage] = useState(false);
  const [snackBarMessageData, setsnackBarMessageData] = useState("");
  const [snackBarMessageType, setsnackBarMessageType] = useState("success");
  const handlesnackBarMessageClose = () => {
    setsnackBarMessage(false);
  };
console.log("data",data)
  const handleServiceTitleChange = (e, id) => {
    const value = e.target.value;
    setSelectedServices((prev) =>
      prev.map((service) =>
        service.id === id ? { ...service, service_title: value } : service
      )
    );
  };

  const handleUnitCostChange = (e, id) => {
    const value = parseFloat(e.target.value) || 0;
    setSelectedServices((prev) =>
      prev.map((service) =>
        service.id === id ? { ...service, unit_cost: value } : service
      )
    );
  };

  useEffect(() => {
    ApiServices.get(
      `/apis/default/api/allowedServiceDsicount/${LoginUserData.id}`,
      {
        Authorization: `Bearer ${AccessToken}`,
      }
    ).then((response) => {
      const servicesWithData = response.data.map((service, index) => ({
        ...service,
        id: index + 1,
        discount: 0,
      }));
      setDoctorServices(servicesWithData);
      setFilteredServices(servicesWithData);
    });
  }, [AccessToken, LoginUserData.id]);

  useEffect(() => {
    axios
      .get(`https://cosmosapi.medispacosmos.com/api/products/`)
      .then((response) => {
        const activeProducts = response.data.filter(
          (product) => product.active_status
        );
        setAllProducts(activeProducts);
        setFilteredProducts(activeProducts);
      });
  }, []);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    const filteredServiceData = doctorServices.filter((service) => {
      const labelOnBill = service?.label_on_bill?.toLowerCase() || "";
      const serviceType = service?.service?.toLowerCase() || "";
      const serviceSubtype = service?.service_subtype?.toLowerCase() || "";
      return (
        labelOnBill.includes(searchTerm) ||
        serviceType.includes(searchTerm) ||
        serviceSubtype.includes(searchTerm)
      );
    });

    const filteredProductData = allProducts.filter((product) => {
      const title = product?.title?.toLowerCase() || "";
      return title.includes(searchTerm);
    });

    setFilteredServices(filteredServiceData.slice(0, 10));
    setFilteredProducts(filteredProductData.slice(0, 10));
  };

  const handleCheckboxChange = (event, item, type) => {
    if (event.target.checked) {
      if (type === "service") {
        setSelectedServices((prevSelected) => [
          ...prevSelected,
          {
            ...item,
            id: item.id,
            service_title: item.label_on_bill,
          },
        ]);
      } else {
        setSelectedProducts((prevSelected) => [
          ...prevSelected,
          {
            ...item,
            id: item.id,
            product_title: item.title,
          },
        ]);
      }
      setQuantities((prevQuantities) => ({
        ...prevQuantities,
        [item.id]: 1,
      }));
      setServiceNotes((prevNotes) => ({
        ...prevNotes,
        [item.id]: "",
      }));
      setDiscounts((prevDiscounts) => ({
        ...prevDiscounts,
        [item.id]:
          type === "service" ? Math.min(parseFloat(item.percent_off), 0) : 0,
      }));
    } else {
      if (type === "service") {
        setSelectedServices((prevSelected) =>
          prevSelected.filter((service) => service.id !== item.id)
        );
      } else {
        setSelectedProducts((prevSelected) =>
          prevSelected.filter((product) => product.id !== item.id)
        );
      }
      setQuantities((prevQuantities) => {
        const updatedQuantities = { ...prevQuantities };
        delete updatedQuantities[item.id];
        return updatedQuantities;
      });
      setServiceNotes((prevNotes) => {
        const updatedNotes = { ...prevNotes };
        delete updatedNotes[item.id];
        return updatedNotes;
      });
      setDiscounts((prevDiscounts) => {
        const updatedDiscounts = { ...prevDiscounts };
        delete updatedDiscounts[item.id];
        return updatedDiscounts;
      });
    }
  };

  const handleQuantityChange = (event, id) => {
    const { value } = event.target;
    setQuantities((prevQuantities) => ({
      ...prevQuantities,
      [id]: Math.max(parseInt(value, 10), 1) || 1,
    }));
  };

  const handleNoteChange = (event, id) => {
    const { value } = event.target;
    setServiceNotes((prevNotes) => ({
      ...prevNotes,
      [id]: value,
    }));
  };

  const handleDiscountChange = (event, id) => {
    const { value } = event.target;
    setDiscounts((prevDiscounts) => ({
      ...prevDiscounts,
      [id]: parseFloat(value),
    }));
  };



  const applyDiscount = (id, amount, type) => {
    if (type === "service") {
      const service = selectedServices.find((service) => service.id === id);
      if (!service) return amount;
      const quantity = quantities[id] || 1;
      const unitCost = parseFloat(service.unit_cost);
      const serviceDiscount = discounts[id] || 0;
      const maxDiscount = parseFloat(service.percent_off);
      const appliedDiscount = Math.min(serviceDiscount, maxDiscount);
      const discountAmount = (unitCost * quantity * appliedDiscount) / 100;
      const discountedAmount = amount - discountAmount;
      return discountedAmount;
    } else {
      const product = selectedProducts.find((product) => product.id === id);
      if (!product) return amount;
      const quantity = quantities[id] || 1;
      const unitCost = parseFloat(product.price);
      const productDiscount = discounts[id] || 0;
      const discountAmount = (unitCost * quantity * productDiscount) / 100;
      const discountedAmount = amount - discountAmount;
      return discountedAmount;
    }
  };

  const handleSubmit = async () => {
    const currentDate = new Date().toISOString().split("T")[0];
    const postData = {
      bill_id: "",
      pid: data.pid,
      eid: data.eid,
      date_of_billing: currentDate,
      services: selectedServices.map((service) => ({
        service_title: service.label_on_bill,
        service_id: service.service_id,
        service_quantity: quantities[service.id],
        service_discount: discounts[service.id],
        service_default_price: service.unit_cost,
        service_note: serviceNotes[service.id],
        service_provider: LoginUserData.id,
        quantitytodeductfromPackage: "",
        quantityToPay: quantities[service.id],
      })),

      products: selectedProducts.map((product) => ({
        product_id: product.id,
        product_title: product.product_title,
        product_provider: LoginUserData.id,
        product_quantity: quantities[product.id],
        product_discount: discounts[product.id],
        product_default_price: product.price,
        quantitytodeductfromPackage: "",
        quantityToPay: quantities[product.id],
      })),

      modeOfPayment: [
        {
          PartialPaymentAmount: "",
          PartialPaymentMode: "",
        },
        {
          RemainingPaymentAmount: "",
          RemainingPaymentMode: "",
        },
      ],

      tip: 0,
      amount_after_tip: 0,
      is_billed: 0,
      verified_receptionist: 0,
      cash: 0,
      wallet_money: 0,
      credit_card: 0,
      partialPayment: null,
      RemainingPayment: null,
      transactionIdofpartialPayment: "",
      transactionIdofRemainingPayment: "",
      platformFeeforCard: "",
    };

    try {
      const response = await ApiServices.post(
        "/apis/default/api/billingweb",
        postData,
        {
          Authorization: `Bearer ${AccessToken}`,
        }
      );
      console.log(response.data);

      ApiServices.put(
        `/apis/default/api/patient/${data.pc_pid}/appointment/${data.pc_eid}`,
        {
          pc_catid: data.pc_catid,
          pc_title: data.pc_title,
          pc_duration: data.pc_duration,
          pc_hometext: data.pc_hometext,
          pc_apptstatus: data.pc_apptstatus,
          pc_eventDate: data.pc_eventDate,
          pc_startTime: data.pc_startTime,
          pc_facility: data.pc_facility,
          pc_billing_location: data.pc_billing_location,
          pc_aid: data.pc_aid,
          client_type: data.client_type,
          wallet_id: data.wallet_id,
          user_type: data.user_type,
          is_billed: 0,
          assigned_by: data.assigned_by,
          appointment_note: data.appointment_note,
          appointment_type: data.appointment_type,
          soap_note: data.soap_note,
          verified_receptionist: 0,
          generated_bill_provider: 1,
        },
        {
          Authorization: `Bearer ${AccessToken}`,
          "Content-Type": "application/json",
        }
      );
      setSelectedServices([]);
      setSelectedProducts([]);
      setQuantities({});
      setServiceNotes({});
      setDiscounts({});
      onBillCreated();
      setsnackBarMessage(true)
      setsnackBarMessageType("success")
      setsnackBarMessageData("Bill Created Successfully!")
    } catch (error) {
      console.error(error);
      setsnackBarMessage(true)
      setsnackBarMessageType("error")
      setsnackBarMessageData("Something Went Wrong!")
    }
  };

  const serviceColumns = [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "service_id", headerName: "Service ID", flex: 1 },
    { field: "service", headerName: "Service", flex: 1 },
    { field: "service_subtype", headerName: "Service Subtype", flex: 1 },
    { field: "label_on_bill", headerName: "Label on Bill", flex: 1 },
    { field: "unit_cost", headerName: "Unit Cost", flex: 1 },
    { field: "percent_off", headerName: "Discount", flex: 1 },
  ];

  const productColumns = [
    { field: "id", headerName: "Product ID", flex: 1 },
    { field: "title", headerName: "Title", flex: 1 },
    { field: "price", headerName: "Price", flex: 1 },
    { field: "active_status", headerName: "Active Status", flex: 1 },
  ];

  return (
    <div style={{ height: "calc(100vh - 64px)", width: "100%" }}>
      <Typography variant="h5" gutterBottom>
        Available Services and Products
      </Typography>
      <TextField
        label="Search"
        variant="outlined"
        fullWidth
        onChange={handleSearchChange}
        style={{ marginBottom: "20px" }}
      />
      {filteredServices.length > 0 || filteredProducts.length > 0 ? (
        <div >
        <div  style={{ height: 400, width: '100%', marginBottom: 20 }}>
          <DataGrid
            rows={filteredServices}
            columns={[
              ...serviceColumns,
              {
                field: "select",
                headerName: "Select",
                renderCell: (params) => (
                  <Checkbox
                    checked={selectedServices.some(
                      (service) => service.id === params.row.id
                    )}
                    onChange={(event) =>
                      handleCheckboxChange(event, params.row, "service")
                    }
                  />
                ),
                sortable: false,
                flex: 1,
              },
            ]}
            pageSize={5}
            rowsPerPageOptions={[5]}
            // autoHeight
            getRowId={(row) => row.id}
            sx={{ overflow: 'auto' }} 
          />
          </div>
          <div  style={{ height: 400, width: '100%', marginBottom: 20 }}>
          <DataGrid
            rows={filteredProducts}
            columns={[
              ...productColumns,
              {
                field: "select",
                headerName: "Select",
                renderCell: (params) => (
                  <Checkbox
                    checked={selectedProducts.some(
                      (product) => product.id === params.row.id
                    )}
                    onChange={(event) =>
                      handleCheckboxChange(event, params.row, "product")
                    }
                  />
                ),
                sortable: false,
                flex: 1,
              },
            ]}
            pageSize={5}
            rowsPerPageOptions={[5]}
            // autoHeight
            getRowId={(row) => row.id}
            sx={{ overflow: 'auto' }} 
          />
        </div>
        </div>
      ) : (
        <Typography variant="body2">No data available</Typography>
      )}

      <Typography variant="h5" gutterBottom style={{ marginTop: "40px" }}>
        Selected Services and Products
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Item</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Notes</TableCell>
              <TableCell>Unit Cost</TableCell>
              <TableCell>Discount (%)</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Discounted Price</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedServices.map((service) => (
              <TableRow key={service.id}>
                {/* <TableCell>{service.label_on_bill}</TableCell> */}
                <TableCell>
              {service.service === "miscellaneous" ? (
                <TextField
                  placeholder="Enter service title"
                  value={service.service_title || ""}
                  onChange={(e) => handleServiceTitleChange(e, service.id)}
                />
              ) : (
                service.service_title || "N/A"
              )}
            </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={quantities[service.id] || 1}
                    onChange={(e) => handleQuantityChange(e, service.id)}
                    InputProps={{
                      inputProps: { min: 1 },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              handleQuantityChange(
                                {
                                  target: { value: quantities[service.id] - 1 },
                                },
                                service.id
                              )
                            }
                          >
                            <RemoveCircleOutline />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              handleQuantityChange(
                                {
                                  target: { value: quantities[service.id] + 1 },
                                },
                                service.id
                              )
                            }
                          >
                            <AddCircleOutline />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextareaAutosize
                    minRows={3}
                    value={serviceNotes[service.id]}
                    onChange={(e) => handleNoteChange(e, service.id)}
                  />
                </TableCell>
                {/* <TableCell>{service.unit_cost}</TableCell> */}
                <TableCell>
              {service.service === "miscellaneous" ? (
                <TextField
                  type="number"
                  value={service.unit_cost || ""}
                  onChange={(e) => handleUnitCostChange(e, service.id)}
                  InputProps={{
                    inputProps: { min: 0 },
                  }}
                />
              ) : (
                service.unit_cost || "N/A"
              )}
            </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={discounts[service.id] || 0}
                    onChange={(e) => handleDiscountChange(e, service.id)}
                    InputProps={{
                      inputProps: { min: 0, max: service.percent_off },
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                  />
                </TableCell>
                <TableCell>
                  {parseFloat(service.unit_cost) *
                    (quantities[service.id] || 1)}
                </TableCell>
                <TableCell>
                  {applyDiscount(
                    service.id,
                    parseFloat(service.unit_cost) *
                      (quantities[service.id] || 1),
                    "service"
                  ).toFixed(2)}
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() =>
                      handleCheckboxChange(
                        { target: { checked: false } },
                        service,
                        "service"
                      )
                    }
                  >
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {selectedProducts.map((product) => (
              <TableRow key={product.id}>
                <TableCell>{product.title}</TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={quantities[product.id] || 1}
                    onChange={(e) => handleQuantityChange(e, product.id)}
                    InputProps={{
                      inputProps: { min: 1 },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() =>
                              handleQuantityChange(
                                {
                                  target: { value: quantities[product.id] - 1 },
                                },
                                product.id
                              )
                            }
                          >
                            <RemoveCircleOutline />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              handleQuantityChange(
                                {
                                  target: { value: quantities[product.id] + 1 },
                                },
                                product.id
                              )
                            }
                          >
                            <AddCircleOutline />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextareaAutosize
                    minRows={3}
                    value={serviceNotes[product.id]}
                    onChange={(e) => handleNoteChange(e, product.id)}
                  />
                </TableCell>
                <TableCell>{product.price}</TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    value={discounts[product.id] || 0}
                    onChange={(e) => handleDiscountChange(e, product.id)}
                    InputProps={{
                      inputProps: { min: 0, max: 100 },
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                  />
                </TableCell>
                <TableCell>
                  {parseFloat(product.price) * (quantities[product.id] || 1)}
                </TableCell>
                <TableCell>
                  {applyDiscount(
                    product.id,
                    parseFloat(product.price) * (quantities[product.id] || 1),
                    "product"
                  ).toFixed(2)}
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() =>
                      handleCheckboxChange(
                        { target: { checked: false } },
                        product,
                        "product"
                      )
                    }
                  >
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="flex-end" marginTop="20px">
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Box>

      <Snackbar
        open={snackBarMessage}
        autoHideDuration={6000}
        onClose={handlesnackBarMessageClose}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handlesnackBarMessageClose}
          severity={snackBarMessageType}
        >
          {snackBarMessageData}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default CreateBill;
